<template>
	<v-dialog 
		v-model="dialog" 
		max-width="500px"
	>
		<!-- Актіватор -->
		<template v-slot:activator="{ on: dialog, attrs }">
			<slot name="activator" :attrs="attrs" :dialog="dialog">
				<v-btn icon v-bind="attrs" v-on="{ ...dialog }">
					<v-icon>{{ activatorIcon }}</v-icon>
				</v-btn>
			</slot>
		</template>

		<v-card>
			<v-card-title>
				{{ title }}
				<v-spacer></v-spacer>
				<v-btn icon @click="dialog=false" >
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<!-- <v-divider></v-divider> -->
			<v-card-text class="text-center">
				<div>Ви дійсно бажаєте здійснити видалення?</div>
				<div>Дані будуть видалені без можливості їх подальшого відновлення!</div>
				<!-- <p class="text-subtitle-1 font-weight-black">Ви дійсно бажаєте здійснити видалення?</p>
				<p class="text-subtitle-1 font-weight-black">Дані будуть видалені без можливості їх подальшого відновлення!</p> -->
			</v-card-text>
			<!-- <v-divider></v-divider> -->
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text @click="onCancel">Відхилити</v-btn>
				<v-btn color="success" @click="onOK">Підтверджую</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>

export default {
	components: {

	},
	data: () => ({
		//title: 'Are you sure you want to delete this item?',
		//title: 'Ви дійсно бажаєте видалити цей запис?',
		title: 'Видалення',
		icon: 'mdi-account-tie',
		dialog: false,
		tooltipDisabled: false,
	}),
	props: {
		selected: 		{ type: Object, default: () => {} },
		disabled:   	{ type: Boolean, default: false }, //Ознака неактивного елементу
		activatorType:  { type: String, default: 'icon'}, // Тип активатора вікна: button | icon | menu-item | list-item
		activatorIcon:  { type: String, default: 'mdi-trash-can'},
		tooltip:  		{ type: String, default: 'Видалити'},
	},

	watch: {
		
	},
	
	computed: {

	},

	methods: {
		onCancel () {
			this.dialog = false
		},

		onOK () {
			this.dialog = false
			this.$emit('ok')
		},
	},
}
</script>